import { render, staticRenderFns } from "./SearchSideBar.vue?vue&type=template&id=0aef5c18&scoped=true&"
import script from "./SearchSideBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchSideBar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aef5c18",
  null
  
)

export default component.exports